"use client";
import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { Root as v, Trigger as b, Portal as k, Content as C, Arrow as O } from "@radix-ui/react-tooltip";
import { Provider as E } from "@radix-ui/react-tooltip";
import { forwardRef as y, useState as T, useEffect as W } from "react";
import { twMerge as z } from "tailwind-merge";
import { Text as c } from "./index.es4.js";
function H() {
  try {
    return matchMedia("(hover: hover)").matches;
  } catch {
    return !0;
  }
}
const R = y(
  ({
    className: i = "",
    contentProps: d = {},
    description: r,
    hasArrow: f = !0,
    title: a,
    trigger: u,
    variant: s = "dark",
    ...e
  }, m) => {
    const [o, n] = T(!1);
    W(() => {
      e != null && e.defaultOpen && n(!0);
    }, [e == null ? void 0 : e.defaultOpen]);
    const g = z(
      `rounded shadow-level1-soft p-3 z-[1050] ${s === "light" ? "bg-white text-black" : "bg-black text-white"}`,
      i
    ), x = r ? "semibold" : "regular", w = H();
    let h = {};
    return w || (e = {
      ...e,
      open: o,
      onOpenChange: () => n(!1)
    }, h = {
      onClick: () => n(!0)
    }), /* @__PURE__ */ l(v, { delayDuration: 0, ...e, children: [
      /* @__PURE__ */ t(b, { ref: m, asChild: !0, ...h, children: u }),
      (a || r) && /* @__PURE__ */ t(k, { children: /* @__PURE__ */ l(
        C,
        {
          "data-testid": "tooltip-content",
          className: g,
          sideOffset: 4,
          hideWhenDetached: !0,
          ...d,
          children: [
            f && /* @__PURE__ */ t(
              O,
              {
                className: `fill-current drop-shadow-level1-soft mask-clip ${s === "light" ? "text-white" : "text-black"}`,
                style: { clipPath: "inset(0 -10px -10px -10px)" }
              }
            ),
            /* @__PURE__ */ l("div", { className: "flex flex-col gap-y-1.5 max-w-xs", children: [
              a && /* @__PURE__ */ t(c, { fontSize: "sm", fontWeight: x, asChild: !0, children: /* @__PURE__ */ t("span", { children: a }) }),
              r && /* @__PURE__ */ t(c, { fontSize: "xs", fontWeight: "regular", children: r })
            ] })
          ]
        }
      ) })
    ] });
  }
);
export {
  R as Tooltip,
  E as TooltipProvider
};
